import React, {  useState } from "react";
import { Text, View,TouchableOpacity} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize} from "rn-responsive-styles";
import { COLORS } from "../constant";
import CView from "./CView";
import CText from "./CText";
import CImage from "./CImage";
import CCheckbox from "./CCheckBox"
export default function ModalAlertMultipleButtons(props) {
    const styles = useStyles();
    const success = "success";
    const [isChecked, setIsChecked] = useState(false);
    return (
        <CView style={styles.container}>
            <View style={styles.overlay}>
                <View style={styles.contentWidget}>
                    {
                        props.closeModal
                            ? <TouchableOpacity style={{ alignSelf: "flex-end", }} onPress={() => props.onCloseModal()}>
                                <Text style={{ marginTop: 15, marginRight: 15, color: "#bd2d37", fontFamily: "Inter" }}>
                                    {"X"}
                                </Text>
                            </TouchableOpacity>
                            : null
                    }
                    <CText.modalTitle>{props.title}</CText.modalTitle>

                    {props.status === success ? (
                        <CImage.IconSuccess></CImage.IconSuccess>
                    ) : props.status == 'No Status' ?
                        <View style={styles.noIcon} />
                        : (
                          <CImage.IconError></CImage.IconError>
                        )}
                    <CText.modalMsg>{props.message} </CText.modalMsg>
                    <CView FR>
                        <CText.benifitText>{props.bullet} </CText.benifitText>
                        <CText.modalMsg> {props.bulletMessage} </CText.modalMsg>
                    </CView>
                    <CView FR FS style={{alignSelf:'flex-start'}}>
                    {props.checkBox != "" && (
                    <CCheckbox
                            termsText={`Yes, I agree`}
                            setIsTermsChecked={setIsChecked}
                            isTermsChecked={isChecked}
                        />)}
                        <CText.modalMsg> {props.checkBoxMsg} </CText.modalMsg>
                    </CView>
                    {props.actionButton != "" && (
                        <CView style={styles.footer}>
                            <TouchableOpacity
                                onPress={() => props.onPressActionButton1()}
                                style={styles.footerBtn}
                            >
                                <CText.modalFooterLink style={{color: props.color1 ? props.color1 : "#9d1d27"}}>{props.cancelButton} </CText.modalFooterLink>
                            </TouchableOpacity>
                            <TouchableOpacity
                                onPress={() => isChecked ? props.onPressActionButton2() : ''}
                                style={[styles.footerBtn, { backgroundColor: isChecked ? props.backgroundColor : COLORS.gray }]}
                            >
                                <CText.modalFooterLink style={{color: props.color}}>{props.proceedButton} </CText.modalFooterLink>
                            </TouchableOpacity>
                        </CView>
                    )}
                </View>
            </View>
        </CView>
    );
}

const useStyles = CreateResponsiveStyle({
    container: {
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 99999,
    },
    overlay: {
        width: "100%",
        height: "100%",
        justifyContent: "center",
        alignItems: "center",
    },
    contentWidget: {
        backgroundColor: "white",
        width: '60%',
        minHeight: 240,
        borderRadius: 20,
        paddingTop:20,
        paddingHorizontal: 40,
        justifyContent: "flex-start",
        alignItems: "center",
        shadowColor: "rgba(0,0,0,0.05)",
        shadowOpacity: 1.5,
        elevation: 12,
        shadowRadius: 20,
        shadowOffset: { width: 1, height: 13 },
    },
    noIcon: {
        marginTop: 20,
        height: 20,
    },
    title: {
        color: "#5a5755",
        fontFamily: "Inter",
        fontSize: 18,
        alignSelf: "center",
        marginTop: 25,
    },
    footer: {
        width: "100%",
        bottom: 0,
        paddingVertical: 20,
        alignItems: "center",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 10
    },
    footerBtn: {
        minWidth: 140,
        height: 40,
        borderRadius: 16,
        paddingVertical: 10,
        paddingHorizontal: 10,
        alignItems: "center",
        marginHorizontal: 10,
        borderColor:'#d6d6d6',
        borderWidth:1
    },
},
    {
        [maxSize(DEVICE_SIZES.XS)]: {
            contentWidget: {
                backgroundColor: "white",
                width: "90%",
                minHeight: 240,
                borderRadius: 20,
                justifyContent: "flex-start",
                alignItems: "center",
                shadowColor: "rgba(0,0,0,0.05)",
                shadowOpacity: 1.5,
                elevation: 12,
                shadowRadius: 20,
                shadowOffset: { width: 1, height: 13 },
            },
            overlay: {
                width: "100%",
                height: "100%",
                justifyContent: "flex-start",
                alignItems: "center",
                marginTop: "40%"
            },
        }
    },);
